export class ContactDetailsSession {
    public name: string = '';
    public email: string = '';
    public phone: string = '';
    public ext: string = '';
    
    public makePrimaryContact: boolean = false;

    public primaryName: string = '';
    public primaryEmail: string = '';
    public primaryPhone: string = '';
    public primaryExt: string = '';
}